import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=5073c6eb&scoped=true"
import script from "./ordersDetails.vue?vue&type=script&lang=js"
export * from "./ordersDetails.vue?vue&type=script&lang=js"
import style0 from "./ordersDetails.vue?vue&type=style&index=0&id=5073c6eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073c6eb",
  null
  
)

export default component.exports